package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.delete_product_set


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.SetModel

@Serializable
data class SetProductSets(
    @SerialName("id")
    val id: String?,
    @SerialName("mod_ver")
    val modVer: Int?,
    @SerialName("sets")
    val sets: List<SetModel>?,
    @SerialName("__typename")
    val typename: String?
)